import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import HoverComponent from '../../../_partials/HoverComponent/HoverComponent';
import { useSubmitMenuItem } from '../../../useSubmitMenuItem';
import BetaBadge from '../../../../BetaBadge';
import s from './SubmitMenuItem.scss';
var SubmitMenuItem = function (_a) {
    var className = _a.className, hoverComponentClassName = _a.hoverComponentClassName, type = _a.type, modalType = _a.modalType, modalOptions = _a.modalOptions, svg = _a.svg, label = _a.label, link = _a.link, target = _a.target, verificationAction = _a.verificationAction, showDaProtect = _a.showDaProtect, isNew = _a.isNew, showNewByTitle = _a.showNewByTitle, isLegacyHeader = _a.isLegacyHeader, role = _a.role;
    var t = useTranslation().t;
    var _b = useSubmitMenuItem({
        modalType: modalType,
        link: link,
        verificationAction: verificationAction,
        type: type,
        modalOptions: modalOptions,
        isLegacyHeader: isLegacyHeader,
    }), onClick = _b.onClick, href = _b.href, biData = _b.biData;
    var ai_art_generator = useFlag('ai_art_generator');
    var smallersubmit = useFlag('smallersubmit');
    if (type === 'dreamup' && !ai_art_generator) {
        return null;
    }
    if (ai_art_generator && smallersubmit) {
        if (type === 'status' || type === 'journal' || type === 'poll') {
            return null;
        }
    }
    else {
        if (type === 'post') {
            return null;
        }
    }
    return (React.createElement(PlainButtonOrLink, { className: c(className, s['new-container']), href: href, target: target, tabIndex: 0, onClick: onClick, biData: biData, isFakeButton: !onClick, role: role },
        t(label),
        showNewByTitle && (React.createElement(BetaBadge, { badgeType: "new", className: s['new-badge'], variant: "medium" })),
        svg && (React.createElement(HoverComponent, { svg: svg, title: t("".concat(label, ".title")), context: t("".concat(label, ".context")), className: hoverComponentClassName, isNew: isNew && !ai_art_generator, showDaProtect: showDaProtect && !(ai_art_generator && smallersubmit) }))));
};
SubmitMenuItem.displayName = 'SubmitMenuItem';
export default SubmitMenuItem;
//# sourceMappingURL=SubmitMenuItem.js.map